import {toastr} from 'react-redux-toastr';
import {initialize, change, reset, formValueSelector} from 'redux-form';
import {validateEmail} from 'shared/validators';
import {
  getJsonAsync,
  postJsonAsync,
  navigateTo,
  handlePrint
} from 'shared/actions';
import {
  changeEntryCaptain
} from '../entryDetail/actions';
import {
  setPaymentVirtualEvents,
  displayPaymentEntries,
  setPaymentEntries,
  setPayments,
  displayNotesModalVisibility,
  setCaptainDetails,
  setCaptainTournamentEntries,
  setCaptainBalanceDue,
  setVirtualEventSelected,
  setEntrySelected,
  calculateSelectedBalance,
  disableOtherTournamentSelection,
  displayCaptainDetailPaymentModal,
  displayUpdateModal,
  displayEntryDetailChangeCaptainModal,
  hideEntryDetailChangeCaptainModal,
  setIsNewCaptainOnSearch,
  setAffectedVirtualEntries,
  setchangeMultipleEntriesErrors,
  changeHideCancelledEntries,
  changeHideArchivedEntries,
  setTournamentCollapsed,
  setValidationMessages
} from './actionTypes';
import {
  setErrorList
} from 'shared/error/actionTypes';
import {
  setTitle,
  setSubTitle
} from 'shared/topBanner/actionTypes';

export const handleUpdateClicked = () => (dispatch, getState) => {
  const {captainId, captainFirstName, captainLastName} = getState().admin.captainDetail;

  dispatch(initialize('adminCaptainDetailUpdateForm', {
    captainId,
    captainFirstName,
    captainLastName
  }));
  dispatch(displayUpdateModal(true));
};

export const onHideCancelledEntriesChange = (hideCancelled) => (dispatch, getState) => {
  const captainId = getState().admin.captainDetail.captainId;

  dispatch(changeHideCancelledEntries(hideCancelled));
  dispatch(loadCaptainTournamentEntries(captainId));
};
export const onHideArchivedEntriesChange = (hideArchived) => (dispatch, getState) => {
  const captainId = getState().admin.captainDetail.captainId;

  dispatch(changeHideArchivedEntries(hideArchived));
  dispatch(loadCaptainTournamentEntries(captainId));
};

export const handleCaptainDetailUpdateCancelClick = () => dispatch => {
  dispatch(displayUpdateModal(false));
  dispatch(reset('adminCaptainDetailUpdateForm'));
  dispatch(setErrorList([]));
};

export const handleCaptainDetailUpdateFormSave = data => (dispatch, getState) => new Promise((resolve) => {
  const captainId = getState().admin.captainDetail.captainId;
  const request = {
    captainId: captainId,
    firstName: data.captainFirstName,
    lastName: data.captainLastName
  };

  dispatch(postJsonAsync(`admin/captain/update`, request))
  .then(() => {
    dispatch(displayUpdateModal(false));
    toastr.success('Captain Updated!', 'Captain was updated.');
    dispatch(loadCaptainDetails(captainId));
    resolve();
  })
  .catch(() => {
    toastr.error('Captain Not Updated!', 'There was an error updating the captain.');
    resolve();
  });
});

export const handleEntryLinkClick = entryId => dispatch => {
  dispatch(navigateTo(`admin/entry/${entryId}`));
};

export const handleViewEntriesClick = paymentId => dispatch => {
  dispatch(getJsonAsync(`admin/payments/${paymentId}/entries`))
  .then(response => {
    if(response && !response.entries.length && !response.virtualEvents.length) {
      toastr.warning('Nothing Found', 'No payment\'s entries found');
      return;
    }
    dispatch(setPaymentEntries(response.entries));
    dispatch(setPaymentVirtualEvents(response.virtualEvents));
    dispatch(displayPaymentEntries(paymentId));
  })
  .catch(() => toastr.error('Error', 'An unexpected error was found while getting payment entries'));
};

export const handleChangeEntriesCaptainFormSave = data => (dispatch, getState) => new Promise(() => {
  const captainDetail = getState().admin.captainDetail;
  const tournament = captainDetail.tournaments.find(t => t.selected);
  const entries = tournament.entries
    .filter(entry => entry.selected)
    .map(entry => entry.id);
  const virtualEntries = captainDetail.affectedVirtualEntries
    .filter(entry => entry.selected)
    .map(entry => entry.virtualEntryId);

  const entryData = {
    entries: entries,
    ...data,
    captainId: captainDetail.captainId,
    virtualEntries: virtualEntries
  };

  dispatch(handleChangeEntryCaptainFormSave(entryData));
});

export const handleChangeEntryCaptainFormSave = data => (dispatch) => new Promise(() => {
  const entryId = data.entries.shift();

  const entryData = {
    ...data,
    entries: data.entries
  };

  const request = {
    entryId: entryId,
    firstName: data.captainFirstName,
    lastName: data.captainLastName,
    email: data.captainEmail,
    virtualEntryIds: data.virtualEntries
  };

  dispatch(changeEntryCaptain(request)).then(() => {
    if (data.entries.length === 0) {
      dispatch(loadCaptainTournamentEntries(data.captainId));
      dispatch(handleEntryChangeCaptainCancelClick());
    }
    else {
      // Next Entry 
      dispatch(handleChangeEntryCaptainFormSave(entryData));
    }
  });
});

export const handleChangeEntriesCaptainClick = () => (dispatch, getState) => {  
  const captainDetail = getState().admin.captainDetail;
  const tournament = captainDetail.tournaments.find(t => t.selected);
  const entries = tournament.entries
    .filter(entry => entry.selected)
    .map(entry => entry.id);
    
  const virtualEntries = tournament.virtualEvents
    .filter(entry => entry.selected)
    .map(entry => entry.id);

    if (virtualEntries.length > 0) { 
      dispatch(setchangeMultipleEntriesErrors(
        'Cannot change the captain of virtual entries. ' +
        'Click on the virtual entries and change the captain from the virtual entries page. '));
      return; 
    }
    if (entries.length == 0){
      return; 
    }
    dispatch(setchangeMultipleEntriesErrors(''));
  const request = {
    fromCaptainId: captainDetail.captainId,
    entryIds: entries
  };

  dispatch(postJsonAsync(`admin/captain/affectedvirtualentries`, request))
  .then(response => {
    dispatch(setAffectedVirtualEntries(response.virtualEntries));
    dispatch(displayEntryDetailChangeCaptainModal()); 
  })
  .catch(error => {
    toastr.error('Error changing the captain!', error.toString());
  });
};

export const handleEntryChangeCaptainSearchClick = () => (dispatch, getState) => {
  const selector = formValueSelector('CaptainEntryChangeCaptainForm');
  const captainEmail = selector(getState(), 'captainEmail');

  dispatch(getJsonAsync(`admin/captain/${captainEmail}/email`))
  .then(response => {
    if(response){
      dispatch(change('CaptainEntryChangeCaptainForm', 'captainFirstName', response.captainFirstName));
      dispatch(change('CaptainEntryChangeCaptainForm', 'captainLastName', response.captainLastName));
      dispatch(setIsNewCaptainOnSearch(false));
    }
    else{
      dispatch(change('CaptainEntryChangeCaptainForm', 'captainFirstName', ''));
      dispatch(change('CaptainEntryChangeCaptainForm', 'captainLastName', ''));
      dispatch(setIsNewCaptainOnSearch(true));
    }
  })
  .catch(() => {
    toastr.error('Error getting captain detail!', 'There was an error getting captain detail.');
  });
};

export const validateEntryCaptainChangeForm = data => {
  const errors = {};

  if(!data.captainEmail || !validateEmail(data.captainEmail)) {
    errors.captainEmail = 'Please provide a valid email.';
  }

  if (!data.captainFirstName) {
    errors.captainFirstName = 'Please search for the captain before updating.';
  }

  return errors;
};

export const handleEntryChangeCaptainCancelClick = () => dispatch => {
  dispatch(hideEntryDetailChangeCaptainModal());
  dispatch(reset('CaptainEntryChangeCaptainForm'));
  dispatch(setErrorList([]));
};

export const handlePaymentLogClick = () => (dispatch, getState) => {
  const {captainId, payments} = getState().admin.captainDetail;

  // hide everything by removing data from state
  if(payments.length) {
    dispatch(clearPaymentLogs());
    return;
  }

  dispatch(getJsonAsync(`admin/captain/${captainId}/payments`))
  .then(payments => {
    if(!payments || !payments.length) {
      toastr.warning('Nothing Found', 'No captain\'s payments found');
      return;
    }
    dispatch(setPayments(payments));
  })
  .catch(() => toastr.error('Error', 'An unexpected error was found while getting captain payments'));
};

export const handleVirtualEventLinkClick = virtualEventId => (dispatch, getState) => {
  const captainId = getState().admin.captainDetail.captainId;

  dispatch(navigateTo(`admin/captain/${captainId}/virtualevent/${virtualEventId}`));
};

export const handleNotesEditClick = () => (dispatch, getState) => {
  const notes = getState().admin.captainDetail.notes;

  dispatch(displayNotesModalVisibility(true));
  dispatch(initialize('adminCaptainDetailNotesForm', {notes}));
  setTimeout(() => {
    // focus field after animatation finished (~800ms) by directly accessing the dom
    document.querySelectorAll('.modal-dialog #captainDetailNotesForm [name=notes]')[0].focus();
  }, 800);
};

export const handleNotesModalCancel = () => dispatch => {
  dispatch(displayNotesModalVisibility(false));
  dispatch(reset('adminCaptainDetailNotesForm'));
};

export const handleNotesModalSave = data => (dispatch, getState) => new Promise((resolve, reject) => {
  const captainDetailState = getState().admin.captainDetail;
  const captainId = captainDetailState.captainId;

  dispatch(postJsonAsync(`admin/captain/${captainId}/notes`, data))
  .then(() => {
    toastr.success('Saved!', 'Notes were successfully saved.');
    dispatch(displayNotesModalVisibility(false));
    dispatch(reset('adminCaptainDetailNotesForm'));
    dispatch(loadCaptainDetails(captainId));
    resolve();
  })
  .catch(error => reject(error));
});

export const clearPaymentLogs = () => dispatch => {
  dispatch(setPayments([]));
  dispatch(setPaymentEntries([]));
};

export const loadCaptainDetails = captainId => dispatch => {
  dispatch(postJsonAsync(`admin/captain/${captainId}`))
  .then(captainDetails => {
    dispatch(setCaptainDetails(captainDetails));
    dispatch(setTitle(`${captainDetails.captainName} (Captain)`));
    dispatch(setSubTitle(`${captainDetails.captainEmail}`));
  });
};

export const loadCaptainTournamentEntries = (captainId, paymentId) => (dispatch, getState) => {
  const hideCancelledEntries = getState().admin.captainDetail.hideCancelledEntries;
  const hideArchivedEntries = getState().admin.captainDetail.hideArchivedEntries;

  let url = `admin/captain/${captainId}/entries/filterEntries/${hideCancelledEntries}/${hideArchivedEntries}`;

  dispatch(postJsonAsync(url))
  .then(response => {
    dispatch(setCaptainTournamentEntries(response.tournaments));
    dispatch(setCaptainBalanceDue(response.balance));
    dispatch(calculateSelectedBalance());
    response.tournaments.forEach(element => {
      dispatch(setTournamentCollapsed(element.id));
    });
  });

  if (paymentId) {
    dispatch(captainPayment(captainId, paymentId));
  }
};

const captainPayment = (captainId, paymentId) => dispatch => {
  dispatch(postJsonAsync(`admin/captain/payment/credit`, {
    BypassWebHooks: localStorage.bypassWebHooks,
    captainId: captainId,
    paymentId: paymentId
  }))
  .then(response => {        
    if (response) toastr.success('Payment Processed!', 'Selected entries were paid successfully.');
    dispatch(loadCaptainTournamentEntries(captainId));
  });

  if (localStorage.bypassWebHooks)
    delete localStorage.bypassWebHooks;
};

export const handleEntryClick = entryId => dispatch => {
  dispatch(navigateTo(`admin/entry/${entryId}`));
};

export const handleVirtualEventSelectChecked = (tournamentId, virtualEventId) => dispatch => {
  dispatch(setVirtualEventSelected(tournamentId, virtualEventId));
  dispatch(disableOtherTournamentSelection(tournamentId));
  dispatch(calculateSelectedBalance());
};

export const handleEntrySelectChecked = (tournamentId, entryId) => dispatch => {
  dispatch(setEntrySelected(tournamentId, entryId));
  dispatch(disableOtherTournamentSelection(tournamentId));
  dispatch(calculateSelectedBalance());
};

export const handlePayBalanceClick = () => (dispatch, getState) => {
  const state = getState();
  const captainId = state.admin.captainDetail.captainId;
  const tournament = state.admin.captainDetail.tournaments.find(x => x.selected);
  const entries = tournament.entries
    .filter(entry => entry.selected)
    .map(entry => entry.id);
  const virtualEvents = tournament.virtualEvents
    .filter(virtualEvent => virtualEvent.selected)
    .map(virtualEvent => virtualEvent.virtualEventId);
  let body = {
    captainId: captainId,
    entries: entries,
    source: 'captainDetail',
    tournamentId: tournament.id,
    virtualEvents: virtualEvents
  };

  dispatch(postJsonAsync(`admin/captain/createSession`, body))
  .then(response => {
    const publishableKey = tournament.stripePublishableKey;
    const stripe = window.Stripe(publishableKey);
    const sessionId = response.paymentId;
    const errorMessages = response.messages;

    if (errorMessages && errorMessages.length > 0) {
      dispatch(setValidationMessages(errorMessages));
    }
    else {
      stripe.redirectToCheckout({
        sessionId
      });
    }
  });
};

export const handlePayBalanceOtherClick = () => (dispatch, getState) => {
  const amount = getState().admin.captainDetail.selectedBalance;

  dispatch(initialize('adminCaptainPaymentForm', {
    amount: amount
  }));
  dispatch(displayCaptainDetailPaymentModal(true));
};

export const handlePayBalanceOtherCancelClick = () => dispatch => {
  dispatch(setErrorList([]));
  dispatch(displayCaptainDetailPaymentModal(false));
  dispatch(reset('adminEntryPaymentForm'));
};

export const handlePayBalanceOtherAcceptClick = data => (dispatch, getState) => new Promise((resolve) => {
  const state = getState().admin.captainDetail;
  const captainId = state.captainId;
  const tournament = state.tournaments.find(t => t.selected);
  const entries = tournament.entries
          .filter(entry => entry.selected)
          .map(entry => entry.id);
  const virtualEvents = tournament.virtualEvents
    .filter(virtualEvent => virtualEvent.selected)
    .map(virtualEvent => virtualEvent.virtualEventId);

  const body = {
    ...data,
    tournamentId: tournament.id,
    captainId,
    entries,
    virtualEvents
  };

  if (body.stripeTransactionId) body.stripeTransactionId = body.stripeTransactionId.trim();

  dispatch(postJsonAsync(`admin/captain/payment/other`, body))
  .then(() => {
    toastr.success('Saved!', 'Payment was successfully saved.');
    dispatch(setErrorList([]));
    dispatch(displayCaptainDetailPaymentModal(false));
    dispatch(reset('adminCaptainPaymentForm'));
    dispatch(loadCaptainTournamentEntries(captainId));
    resolve();
  })
  .catch(() => resolve());
});

export const handlePrintConfirmationClick = paymentId => dispatch => {
  dispatch(getJsonAsync(`admin/payments/${paymentId}/printable`))
    .then(payload => dispatch(handlePrint(payload)));
}; 



// WEBPACK FOOTER //
// ./src/features/admin/captainDetail/actions.js